import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ContactInfoWidget from '../Widget/ContactInfoWidget';

export default function ContactPage() {
  pageTitle('Contact Us');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeading
        title="Contact Us"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Contact"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title="TUR DER HOFFNUNG <br/>Merchant Information"
              subtitle="Contact"
            />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="30" md="20" />
            <a
              href="https://turderhoffnung.com"
              target="_blank"
              rel="noreferrer"
              className="cs-btn cs-style1"
              style={{ display: 'inline-flex', fontSize: 14 }}
            >
              <span><Icon icon="mdi:web" style={{ marginRight: 8, fontSize: 16, verticalAlign: 'middle' }} />Visit Website</span>
              <Icon icon="bi:arrow-right" />
            </a>
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            <form action="#" className="row">
              <Div className="col-sm-6">
                <label className="cs-primary_color">First Name*</label>
                <input type="text" className="cs-form_field" placeholder="First Name" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Last Name*</label>
                <input type="text" className="cs-form_field" placeholder="Last Name" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Email*</label>
                <input type="email" className="cs-form_field" placeholder="example@email.com" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Phone*</label>
                <input type="tel" className="cs-form_field" placeholder="+971 XX XXX XXXX" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">Company</label>
                <input type="text" className="cs-form_field" placeholder="Company name" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">Message*</label>
                <textarea
                  cols="30"
                  rows="7"
                  className="cs-form_field"
                  placeholder="Tell us about your project..."
                ></textarea>
                <Spacing lg="25" md="25" />
              </Div>
              <Div className="col-sm-12">
                <button className="cs-btn cs-style1">
                  <span>Send Message</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>
            </form>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      <Div className="cs-google_map">
        <iframe
          src="https://www.google.com/maps?q=50%20Rawdon%20Street%2C%20Freetown%2C%20Sierra%20Leone&z=15&output=embed"
          allowFullScreen
          title="TUR DER HOFFNUNG - Freetown"
        />
      </Div>
      <Spacing lg="50" md="40" />
    </>
  );
}
